import { DecimalPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { Indication } from '@zero/home/domain';
import { BlinkDirective } from '@zero/shared/ui-directives';
import { PriceScalePipe } from '@zero/shared/ui-pipes';
import { InstrumentType } from '@zero/shared/util-models';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  selector: 'home-my-market-overview-item',
  templateUrl: './my-market-overview-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, BlinkDirective, NgClass, DecimalPipe, TranslocoPipe, PriceScalePipe, NgTemplateOutlet],
})
export class MyMarketOverviewItemComponent implements OnInit {
  @Input() public indication: Indication;
  public showLeverageBtn = true;

  ngOnInit(): void {
    //hide leverage button for crypto and WTI
    this.showLeverageBtn = this.indication.instrumentType !== InstrumentType.Crypto && this.indication.isin !== 'XC0007924514';
  }

  public readonly instrumentDetail = commonRoutes.postlogin.instrument_detail;

  public readonly leverageProductsPage = commonRoutes.prelogin.leverageProducts;
}
